import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject, input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { RequestQuoteApiService } from '@shared/modals/request-quote/request-quote-api.service';
import { UtilsService } from '@shared/services/utils.service';
import { Subject, EMPTY } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { QuoteDetailsComponent } from './components/quote-details/quote-details.component';

@Component({
  selector: 'app-request-quote',
  templateUrl: './request-quote.component.html',
  styleUrls: ['./request-quote.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatError, QuoteDetailsComponent]
})
export class RequestQuoteComponent implements OnInit, OnDestroy {
  private fb = inject(UntypedFormBuilder);
  private cd = inject(ChangeDetectorRef);
  private utilsService = inject(UtilsService);
  private service = inject(RequestQuoteApiService);

  readonly icao = input(undefined);
  readonly iata = input(undefined);

  @Input()
  set id(val) {
    this.airportId = val;
    this.data = null;
    this.form && this.form.reset();
  }


  airportId: number;
  form: UntypedFormGroup;
  showError = false;
  loading = false;
  destroyed = new Subject<void>();
  data: any;

  flightTypeList = [
    {
      value: 0,
      label: 'Commercial (Part 135)'
    },
    {
      value: 1,
      label: 'Executive or Private (Part 91)'
    },
  ];

  destinationTypeList = [
    {
      value: 0,
      label: 'Domestic'
    },
    {
      value: 1,
      label: 'International'
    }
  ];

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  ngOnInit() {
    this.form = this.fb.group({
      flightType: [null, Validators.required],
      departureType: [null, Validators.required]
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
  }

  onSubmit() {
    this.utilsService.setFormTouched(this.form);

    if (this.form.invalid) {
      return;
    }

    this.loading = true;

    this.service
      .getRequestQuote(this.airportId, this.form.value)
      .pipe(
        catchError(err => {
          this.showError = true;
          this.cd.detectChanges();
          return EMPTY;
        }),
        takeUntil(this.destroyed)
      )
      .subscribe(
        (data) => {
          this.loading = false;
          this.data = data;
          this.cd.detectChanges();
        }
      );
  }
}
